import { render, staticRenderFns } from "./SearchGeneralGeodirOlva.vue?vue&type=template&id=b2aa4ade"
import script from "./SearchGeneralGeodirOlva.vue?vue&type=script&lang=js"
export * from "./SearchGeneralGeodirOlva.vue?vue&type=script&lang=js"
import style0 from "./SearchGeneralGeodirOlva.vue?vue&type=style&index=0&id=b2aa4ade&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports